var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockedRecipients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 608,
    height: 608,
    viewBox: "0 0 608 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304 608C471.895 608 608 471.895 608 304C608 136.105 471.895 0 304 0C136.105 0 0 136.105 0 304C0 471.895 136.105 608 304 608ZM304 526C426.607 526 526 426.607 526 304C526 181.393 426.607 82 304 82C181.393 82 82 181.393 82 304C82 426.607 181.393 526 304 526Z",
    fill: "#D70000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 456.453,
    width: 514,
    height: 82,
    transform: "rotate(-45 93 456.453)",
    fill: "#D70000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedRecipients);
export default __webpack_public_path__ + "static/media/blocked_recipients.6ef69105067cbb4b4d501c46c8046622.svg";
export { ForwardRef as ReactComponent };